<template>
  <div class="PostConfirm">
    <el-dialog
      :title="title"
      destroy-on-close
      :visible.sync="dialogVisible"
      width="540px"
      @open="onVisibleChange"
      @close="onVisibleChange"
      :show-close="false"
      class="dialog-common"
    >
      <slot>
        <el-form :model="community" :rules="rules" ref="postForm" class="demo-ruleForm">
          <el-form-item label="请选择发帖类型" prop="postType">
            <el-radio-group v-model="community.postType">
              <el-radio :label="1">图文帖</el-radio>
              <el-radio :label="2">视频帖</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </slot>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel" size="medium">取消</el-button>
        <el-button type="primary" @click="onConfirm" size="medium"> 确定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PostConfirm',
  props: {
    // .sync
    visible: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '发帖',
    },
    origin: {
      //1:班级 2:社区
      default: '',
    },
    //圈子ID
    groupId: {
      default: '',
    },
  },
  data() {
    return {
      community: {
        postType: '', //发帖类型，1是图文，2是视频
      },
      dialogVisible: false,
      rules: {
        //规则
        postType: [{ required: true, message: '请选择发帖类型', trigger: 'blur' }],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      },
    },
  },
  methods: {
    onConfirm() {
      this.$refs.postForm.validate(async (valid) => {
        //校验
        if (valid) {
          let type = this.community.postType;
          this.onCancel();
          this.$router.push({
            //发帖类型，1是图文，2是视频
            name: 'CommunityPost',
            query: {
              type,
              id: this.groupId,
              origin: this.origin,
            },
          });
        }
      });
    },
    onCancel() {
      //发帖确认取消框
      this.$refs.postForm.resetFields(); //销毁已选
      this.dialogVisible = false;
    },
    onVisibleChange() {
      this.$emit('update:visible', this.dialogVisible);
    },
  },
};
</script>

<style scoped lang="scss">
.PostConfirm {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}
</style>
